import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetYurticiCargoListPagingAndFilterRequest {
    searchTerm: string
    skip?: number
    take?: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    shippingCreateDateStart?: string
    shippingCreateDateEnd?: string
    shippingLoadDateStart?: string
    shippingLoadDateEnd?: string
    selectedCustomer?: CustomSingleSelectModel
    selectedSenderCustomer?: CustomSingleSelectModel
    selectedReceiverCustomer?: CustomSingleSelectModel
    selectedDivision?: CustomSingleSelectModel
    selectedPo?: CustomSingleSelectModel
    selectedSenderCounty?: CustomSingleSelectModel
    selectedReceiverCounty?: CustomSingleSelectModel
    selectedShippingRegion?: CustomSingleSelectModel
    selectedShippingStatuss: CustomMultiSelectModel[]
    selectedSaleInvoiceStatus?: CustomSingleSelectModel
    selectedPurchaseInvoiceStatus?: CustomSingleSelectModel
    ids?: string[]
    isExpectedIncomeEmpty: boolean
    isExpectedOutcomeEmpty: boolean
    selectedExitUnit?: CustomSingleSelectModel
    selectedArrivalUnit?: CustomSingleSelectModel
    /** Kolon başlıklarının altındaki filtreler; Filtreler paneliyle birlikte uygulanır. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetYurticiCargoListPagingAndFilterRequest: GetYurticiCargoListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    sortColumn: undefined,
    sortDirection: undefined,
    currentPage: 1,
    columnChooser: undefined,
    selectedShippingStatuss: [],
    isExpectedIncomeEmpty: false,
    isExpectedOutcomeEmpty: false,
    columnFilters: []
}